<template>
  <!-- <a-radio-group v-model:value="type" button-style="solid" >
    <a-radio-button value="customer">
      消费者
    </a-radio-button>
    <a-radio-button value="store">
      门店
    </a-radio-button>
  </a-radio-group> -->
  <SmallSquare class='m-b-45' content='1.积分说明用于“会员中心-积分明细-积分说明”。请根据您的实际运营情况修改补充说明
2.若使用积分清理功能，请说明积分修改情况' />
  <div class="content customer" v-if="type=='customer'">
    <a-form ref='form' :model='ruleForm' :style="{'marginBottom':'10px'}" :labelCol="{ span:2}"
      :wrapper-col="{ span: 10}" :initialValues="search" :onFinish='pageSearchChange'>
      <a-form-item label="积分说明" name='level'>
        <a-textarea v-model:value="dataMore.consume_explain" placeholder="请输入说明" :rows="10" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 3,offset:2}">
        <a-button type="primary" v-has:pointExplainSetUp="onSubmit">
          保存设置
        </a-button>
      </a-form-item>
    </a-form>
  </div>
  <div class="content store" v-if="type=='store'">
    <a-form ref='form' :model='ruleForm' :style="{'marginBottom':'10px'}" :labelCol="{ span:2 }"
      :wrapper-col="{ span: 10}" :initialValues="search" :onFinish='pageSearchChange'>
      <a-form-item label="积分说明" name='level'>
        <a-textarea v-model:value="dataMore.store_explain" placeholder="请输入说明" :rows="10" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 3,offset:2}">
        <a-button type="primary" v-has:pointExplainSetUp="onSubmit">
          保存设置
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
  import { DownOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { setPoint, getPoint } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
import { isArray } from 'lodash';
  export default {
    name: 'description',
    setup() {
      const state = reactive({
        type:'customer',
        dataMore: {
          consume_explain: '',
          store_explain:''
        }
      });
      const onSubmit = async () => {
        let res = await setPoint(state.dataMore ).then(res => res.data)
        if (iscode(res)) {
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
      }
      const initData = async () => {
        let res = await getPoint().then(res => res.data)
        if (iscode(res)) {
          if(!isArray(res.data)){
            state.dataMore = res.data.values;
          }
        } else {
          message.error(res.msg);
        }
      }
      onMounted(() => {
        initData()
      });
      return {
        ...toRefs(state),
        onSubmit
      };
    }
  };
</script>